/* eslint-disable no-unused-vars */
import React, {
  Component,
  useContext,
  useRef,
  useCallback,
  useEffect,
} from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import survey from '../../../context/survey';
import sendRAT, { ACTION, SCREEN } from '../../../app/rat';
import Permission from '../../permission/Permission';
import surveyState from '../../../app/surveyState';
// import WidgetInquiry from './WidgetInquiry';

/**
 * widget Permission
 * @param {number} index 表示順序 config.step 等価の時に表示します
 * @param {*} state React.Context survey.state
 * @param {function} dispatch React.Context survey.dispatch
 * @return {*} React.node Permission
 * @constructor
 */
const WidgetPermission = ({ index, state, dispatch }) => {
  // /**
  //  * state {object} - {@link config}.reduce 戻り値
  //  * dispatch {function} - {@link config}.Context state 変更関数 - type 指定を行います
  //  */
  // const { state, dispatch } = useContext(survey.Context);

  const { config, step } = state;

  const onCloseClick = useCallback(() => {
    // sendRAT - cId, screen: SCREEN.PERMISSION `toast`, action: ACTION.CLOSE `close`
    sendRAT({
      cId: config.cId.value,
      screen: SCREEN.PERMISSION,
      action: ACTION.CLOSE,
    });
    // /rexsurvey_save_state=false/.test(window.location.search) === false -> 「Surveyへの回答を拒否した」という状態をLocalStorageに保存する - declineSurvey
    if (surveyState.shouldStoreState()) {
      surveyState.storeDecline(
        config.expirationPeriod,
        config.enableDisplaySuppressionPerPage
      );
    }
    // close all - step: -1
    state.type = survey.events.UPDATE;
    state.step = -1;
    dispatch(state);
    // TODO: Permission close -> call to store.submit
  }, [config, state, dispatch]);

  const onCancelClick = useCallback(() => {
    // sendRAT - cId, screen: SCREEN.PERMISSION `toast`, action: ACTION.DISAGREE `disagree`
    sendRAT({
      cId: config.cId.value,
      screen: SCREEN.PERMISSION,
      action: ACTION.DISAGREE,
    });
    // /rexsurvey_save_state=false/.test(window.location.search) === false -> 「Surveyへの回答を拒否した」という状態をLocalStorageに保存する - declineSurvey
    if (surveyState.shouldStoreState()) {
      surveyState.storeDecline(
        config.expirationPeriod,
        config.enableDisplaySuppressionPerPage
      );
    }
    // next step (may be last) to thanks with exclude message - thanks step: 999
    state.type = survey.events.UPDATE;
    state.step = 999;
    dispatch(state);
  }, [config, state, dispatch]);

  const onActionClick = useCallback(() => {
    // sendRAT - cId, screen: SCREEN.PERMISSION `toast`, action: ACTION.AGREE `agree`
    sendRAT({
      cId: config.cId.value,
      screen: SCREEN.PERMISSION,
      action: ACTION.AGREE,
    });
    // next step
    state.type = survey.events.UPDATE;
    state.step = index + 1;
    dispatch(state);
  }, [index, config, state, dispatch]);

  // did update
  useEffect(() => {
    if (step === index) {
      // RAT for appear
      sendRAT({
        cId: config.cId.value,
        screen: SCREEN.PERMISSION,
        action: ACTION.APPEAR,
      });
    }
  }, [step, config.cId.value, index]);

  return (
    step === index && (
      <Permission
        message={state.config.permission.inquiryTxt}
        actionLabel={state.config.permission.yesBtnTxt}
        closeLabel={state.config.permission.noBtnTxt}
        onCloseClick={onCloseClick}
        onCancelClick={onCancelClick}
        onActionClick={onActionClick}
        state={state}
        dispatch={dispatch}
      />
    )
  );
};

export default WidgetPermission;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/widget/sequences/WidgetPermission.js